import {createStore} from 'vuex'
const store = createStore({
    state:{
        windowBoolean:false
    },
    mutations:{
        changeState(state,payload) {
          state.windowBoolean = payload
        }
      },
})
 export default store